let remoteTextCache: Record<string, Record<string, string>> | null = null;

export async function ReinitTextCache() {
  remoteTextCache = await fetchRemoteText();
}

export function GetText(key: string | number, lang = "zh"): [boolean, string] {
  if (remoteTextCache == null) {
    return [false, key.toString()];
  }
  const stringConfig = remoteTextCache[key.toString()];
  if (!stringConfig) {
    return [false, key.toString()];
  }
  let value = stringConfig[lang];
  if (!value) {
    lang = "zh"; // 默认回退到中文
    value = stringConfig[lang];
  }
  if (!value) {
    return [false, key.toString()]; // 如果仍未找到，返回默认值
  }
  return [true, value];
}

async function fetchRemoteText(): Promise<Record<string, Record<string, string>> | null> {
  return new Promise((resolve) => {
    resolve({
      "401": {
        zh: "缺少权限，请重新登陆后重试",
      },
      "404": {
        zh: "接口未找到",
      },
      "1000": {
        zh: "系统错误，请重试或等待管理员修复",
      },
      "1001": {
        zh: "系统异常，请重试或等待管理员修复",
      },
      "1002": {
        zh: "未知错误",
      },
      "1003": {
        zh: "操作过于频繁，请稍后重试",
      },
      "10001": {
        zh: "权限异常，请重新登陆后再试",
      },
      "10002": {
        zh: "参数不符合要求",
      },
      "10003": {
        zh: "未找到目标数据",
      },
      "10004": {
        zh: "操作需要登录，请登录后重试",
      },
      "10005": {
        zh: "用户密码不匹配",
      },
      "10010": {
        zh: "AI 凭据不可用（对应厂商可能已停止支持），请到「用户设置 - AI 大模型」检查并更换密钥",
      },
      "10011": {
        zh: "尚未配置所需的 AI 凭据，请先在「用户设置 - AI 大模型」中添加",
      },
      "100001": {
        zh: "用户名不存在或密码不匹配",
      },
      "100002": {
        zh: "邮件发送失败，可能是邮箱无效或达到了每日注册上限，如有问题可联系管理员解决",
      },
      "100003": {
        zh: "验证码错误或已过期，请重新获取",
      },
      "100004": {
        zh: "注册用户失败，可能存在同名用户",
      },
      "100005": {
        zh: "用户名不存在，或您未在本系统绑定邮箱，请联系管理员寻求帮助",
      },
      "100006": {
        zh: "验证码错误或已过期，请重新获取",
      },
      "100007": {
        zh: "已存在相同标题的题目",
      },
      "100008": {
        zh: "已存在相同标题的比赛",
      },
      "100009": {
        zh: "已存在相同标题的题集",
      },
      "100010": {
        zh: "未发现有效题目",
      },
      "100011": {
        zh: "题目数量超过限制，无法添加",
      },
      "100012": {
        zh: "比赛开始时间无法设置为早于当前时间",
      },
      "100013": {
        zh: "当前无法提交题目",
      },
      "100014": {
        zh: "申请访问失败，密码错误",
      },
      "100015": {
        zh: "未找到目标题目",
      },
      "100016": {
        zh: "已经存在该日期的条目",
      },
      "100017": {
        zh: "已经存在该问题的条目",
      },
      "100018": {
        zh: "请上传包含所有判题数据的zip压缩包",
      },
      "100019": {
        zh: "判题数据不可包含文件夹",
      },
      "100020": {
        zh: "判题数据中rule.yaml解析失败",
      },
      "100021": {
        zh: "判题数据中spj语言不受支持",
      },
      "100022": {
        zh: "判题数据中spj代码读取失败",
      },
      "100023": {
        zh: "判题数据中spj代码编译失败",
      },
      "100024": {
        zh: "判题数据中未读取到有效的任务",
      },
      "100025": {
        zh: "判题数据中任务数量不可超过1000个",
      },
      "100026": {
        zh: "判题数据中任务数据读取失败",
      },
      "100027": {
        zh: "判题数据转码换行符失败",
      },
      "100028": {
        zh: "判题数据计算md5失败",
      },
      "100029": {
        zh: "判题数据上传失败",
      },
      "100030": {
        zh: "暂未开放该问题所使用的远程 OJ 的提交",
      },
      "100031": {
        zh: "压缩包大小限制超过了限制，当前不可超过{max_size}，可联系管理员",
      },
      "100032": {
        zh: "暂不支持更后面的页面，可调整筛选参数更精确的查找",
      },
      "100033": {
        zh: "判题数据中存在预期外的文件",
      },
      "100034": {
        zh: "登录信息已过期，请重新登陆",
      },
      "100035": {
        zh: "目前暂时无法抓取目标OJ题目",
      },
      "100036": {
        zh: "无法获取到指定验证码，请刷新重试",
      },
      "100037": {
        zh: "暂时无法访问 vjudge 信息，请之后再试",
      },
      "100038": {
        zh: "无法从 vjudge 指定用户页获取到验证码，请确认用户名与验证信息有效",
      },
      "100039": {
        zh: "原邮箱验证码错误，请检查输入或重新获取",
      },
      "100040": {
        zh: "新邮箱验证码错误，请检查输入或重新获取",
      },
      "100041": {
        zh: "比赛不存在或者缺少权限",
      },
      "100042": {
        zh: "目标语言当前不允许提交",
      },
      "100043": {
        zh: "代码过短，请检查输入",
      },
      "100044": {
        zh: "今日已经签到过了",
      },
      "100045": {
        zh: "该问题的首通奖励已经领取过了",
      },
      "100046": {
        zh: "用户名已被占用，请更换后重试",
      },
      "100047": {
        zh: "您的网络环境验证失败，请等待一段时间后刷新重试",
      },
      "100048": {
        zh: "比赛标题不能为空",
      },
      "100049": {
        zh: "比赛开始时间不能早于当前时间",
      },
      "100050": {
        zh: "比赛结束时间不能早于开始时间",
      },
      "100051": {
        zh: "比赛持续时间不能超过30天",
      },
      "100052": {
        zh: "比赛已经开始，无法修改开始时间",
      },
      "100053": {
        zh: "比赛已经结束，无法修改结束时间",
      },
      "100054": {
        zh: "包含无效 选手，请检查输入",
      },
      "100055": {
        zh: "选手必须有一个有效的名称",
      },
      "100056": {
        zh: "目前每个用户针对每个游戏只能拥有一个 选手",
      },
      "100057": {
        zh: "手机号验证码错误，请检查输入或重新获取",
      },
      "100059": {
        zh: "需要兑换测试数据",
      },
      "100060": {
        zh: "金币不足，无法兑换",
      },
      "100061": {
        zh: "兑换测试数据失败",
      },
      "100062": {
        zh: "该测试数据不可下载",
      },
      "100066": {
        zh: "模板内容非法，请检查模板是否包含 @EDIT{} 标记",
      },
      "100068": {
        zh: "模板中 @EDIT{} 参数格式错误",
      },
      "100069": {
        zh: "模板中不可编辑区域被修改，请勿擅自改动模板代码，刷新页面后可重置",
      },
      "100070": {
        zh: "模板题不支持当前提交语言，请选择有模板的语言",
      },
      "100078": {
        zh: "生成任务不存在",
      },
      "100079": {
        zh: "生成任务未完成，暂不可应用",
      },
      "100080": {
        zh: "该生成任务已应用",
      },
      "100081": {
        zh: "没有可用的测试点",
      },
      "100082": {
        zh: "AI 服务未配置",
      },
      "100083": {
        zh: "预览数据已过期，请重新生成",
      },
      "100084": {
        zh: "AI 密钥数量已达上限（最多 5 个），请先删除不用的密钥",
      },
      "100085": {
        zh: "不支持的 AI 厂商（可能已停止支持）",
      },
      "100086": {
        zh: "AI 密钥不存在或不属于当前用户",
      },
      "100087": {
        zh: "该厂商已保存过密钥，请先删除原有密钥再重新添加",
      },
      "100088": {
        zh: "AI 密钥连接测试失败",
      },
      "100089": {
        zh: "AI 密钥加密存储失败，请联系管理员",
      },
      "100090": {
        zh: "比赛进行中，暂不可使用该 AI 功能",
      },
      "100091": {
        zh: "评测尚未结束，请等待评测完成后再试",
      },
      "100092": {
        zh: "无权查看该提交",
      },
      "100093": {
        zh: "该提交已有 AI 解析，仅提交者可覆盖",
      },
      "100094": {
        zh: "AI 解析内容校验失败，请重新生成",
      },
      "100095": {
        zh: "当前场景不可用",
      },
      "100096": {
        zh: "会话不存在或不属于当前用户",
      },
      "100098": {
        zh: "消息不能为空",
      },
      "100100": {
        zh: "解析回执校验失败，请重新生成解析（若反复出现请联系管理员）",
      },
      "100101": {
        zh: "服务端处理失败，请稍后重试；若反复出现请联系管理员",
      },
      "100102": {
        zh: "vjudge 暂时无法访问或响应异常，请稍后重试",
      },
      "100103": {
        zh: "缺少权限管理权限，请联系系统管理员",
      },
      "100104": {
        zh: "角色不存在或已被删除，请刷新页面后重试",
      },
      "100105": {
        zh: "用户组不存在或已被删除，请刷新页面后重试",
      },
      "100106": {
        zh: "该角色仍被用户或用户组使用，请先解除引用后再删除",
      },
      "100107": {
        zh: "内置角色与用户组受保护，其标识不可修改、也不可删除",
      },
      "100108": {
        zh: "不能授予超出自身权限范围的能力，也不能修改自己的授权",
      },
      "100109": {
        zh: "该标识已被占用，请更换后重试",
      },
      "100110": {
        zh: "不能移除最后一个超级管理员角色，否则将无人能配置权限",
      },
      // AI 审阅后台与标签管理（100111~100121 / 100126~100127 / 100131）：
      // 这组全是「管理员操作被业务规则拒绝」，文案要让管理员知道下一步该做什么，
      // 而不是只说「操作失败」——否则他只能反复重试同一个动作
      "100111": {
        zh: "缺少题目管理权限，无法使用 AI 审阅与标签管理",
      },
      "100112": {
        zh: "该题目不存在或已被删除，请刷新后重试",
      },
      "100113": {
        zh: "该标签不存在或已被合并，请刷新后重试",
      },
      "100114": {
        zh: "合并目标不合法：不能合并到自己，也不能合并到一个已被合并的词",
      },
      "100115": {
        zh: "当前标签状态不允许该操作（例如批准一个已归档的词），请刷新后重试",
      },
      "100116": {
        zh: "该别名已指向另一个标签：一个别名只能归一到一个词，请先处理旧别名",
      },
      "100117": {
        zh: "该标注不存在或不属于这道题，请刷新后重试",
      },
      "100118": {
        zh: "该标注的审核状态已变更（可能已被其他人处理），请刷新后重试",
      },
      "100120": {
        zh: "未知的标注类型，请刷新后重试",
      },
      "100121": {
        zh: "标注内容校验失败：请检查必填字段、分数范围，以及摘要是否泄露了解法",
      },
      "100122": {
        zh: "缺少题目管理权限，无法查看教练统计",
      },
      "100123": {
        zh: "缺少 AI 厂商管理权限，无法维护厂商白名单",
      },
      "100124": {
        zh: "该厂商不存在或已被删除，请刷新后重试",
      },
      "100125": {
        zh: "厂商标识（key）已存在：key 是稳定标识，不允许重复，请换一个标识",
      },
      "100126": {
        zh: "该展示名已被其他标签占用：标签名全局唯一，请换一个叫法，或先把两个词合并",
      },
      "100127": {
        zh: "展示名不合法：不能为空、不超过 20 个字，也不能只由「问题/算法」这类后缀组成",
      },
      // 非强制的重判（/problem/enrichment/requeue）被状态机拒绝：该题正在处理中。
      // 与 100101 的区别：100101 是「没想到的失败」，这里是预期内的业务规则拒绝（A 档，只记日志）。
      "100131": {
        zh: "该题正在处理中，暂不允许重新入队：请等本轮跑完再试，或在产出详情页点「重判」强制重跑（会重新调用 AI、产生费用）",
      },
      // 比赛榜单回放（关联 / 本体）：100132~100136，均为 A 档预期结果，文案要给管理员可执行的下一步。
      "100132": {
        zh: "该回放关联已不存在（可能刚被移除），请刷新页面后重试",
      },
      "100133": {
        zh: "源比赛与本场的题目不一致：回放要求两边题目完全相同，请换一场题目相同的比赛",
      },
      "100134": {
        zh: "源比赛还没结束：进行中的成绩还会变化，请等它结束后再关联",
      },
      "100135": {
        zh: "本场已经关联过这场源比赛了，无需重复关联",
      },
      "100136": {
        zh: "该源比赛没有可回放的选手成绩（没有提交，或提交都无效）",
      },
      // 比赛榜单回放 · 文件导入：100137~100142。
      "100137": {
        zh: "请先选择要上传的榜单文件，且文件内容不能为空",
      },
      "100138": {
        zh: "榜单文件无法读取或没有数据行（表头之外没有任何记录）：请确认文件是 CSV，且至少有一行选手数据",
      },
      "100139": {
        zh: "文件里没有可回放的选手成绩，请检查榜单内容后重试",
      },
      "100140": {
        zh: "题目映射不合法：每个源题目都要选一个本场存在的题目，且不能重复指向同一题",
      },
      "100141": {
        zh: "预览已失效（超过 30 分钟未确认，或已被使用过），请重新上传榜单文件",
      },
      "100142": {
        zh: "本场比赛还没有题目，无法与榜单对齐：请先给本场比赛加题",
      },
      // 100143 / 100144 由 100138 拆出：缺选手列与缺题目列的改法不同，
      // 共用一句「表头需含选手列与题目列」会让管理员不知道该改哪一边。
      "100143": {
        zh: "榜单文件缺少选手列：表头需要 Handle、用户名或账号 之一（昵称列可选，不能代替选手列）",
      },
      "100144": {
        zh: "榜单文件缺少题目列：表头里的题目必须是单个字母 A、B、C…，并按顺序对应本场题目",
      },
    });
  });
}
